module.exports = __webpack_public_path__ + "static/media/14.234b22a3.jpg";